import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../../../styles/components/project.scss";
import CustomCursor from "../../Cursor";
import { Link } from "react-router-dom";
import ImageFull from "../../../media/art-direction/moyotia/moyotia-full.png";
import ImageHalf1 from "../../../media/art-direction/moyotia/moyotia-half-1.png";
import ImageHalf2 from "../../../media/art-direction/moyotia/moyotia-half-2.png";

export default function Moyotia() {
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="project-focus spacing-block" style={{ paddingTop: "10vh" }}>
      <div className="content">
        <h2 className="title text-6xl">
          {t("art_direction.moyotia.project_name")}
        </h2>
        <h3 className="year text-4xl">2019</h3>
        {/* IMAGES */}
        <div className="images">
          {/* FULL */}
          <div className="row">
            <div className="col-full">
              <img src={ImageFull} alt="" />
            </div>
          </div>
          {/* END FULL */}
        </div>
        {/* END IMAGES */}

        {/* DESCRIPTION */}
        <div className="description">
          <h4 className="text-4xl">{t("art_direction.moyotia.title")}</h4>
          <p className="text-2xl" style={{ textAlign: "center" }}>
            {t("art_direction.moyotia.text")}
          </p>
        </div>

        {/* IMAGES */}
        <div className="images">
          {/* HALF */}
          <div className="row">
            <div className="col">
              <img src={ImageHalf1} alt="" />
            </div>
            <div className="col">
              <img src={ImageHalf2} alt="" />
            </div>
          </div>
          {/* END HALF */}
        </div>
        {/* END IMAGES */}
        <Link to="/art-direction" style={{ color: "inherit" }}>
          <h3 className="close-text text-4xl animated-cursor">
            {t("art_direction.back")}
          </h3>
        </Link>
      </div>
      <CustomCursor />
    </div>
  );
}
